import React, { useState, useEffect } from "react";
import Header from "../../layouts/Header";
import Footer from "../../layouts/Footer";
import { Link, useNavigate, useLocation } from "react-router-dom";
import mairieLogo from "../../assets/img/nrf.png";

import Select from 'react-select';
import { 
  Card, 
  Row, 
  Col, 
  Form, 
  Button, 
  Spinner, 
  Alert,
  ProgressBar,
  Modal,
  Badge,
  Table,
  
} from "react-bootstrap";
import axios from "axios";
import {
  CheckCircle,
  Printer,
  Save,
  Building,
  Phone,
  GeoAlt,
  Person,
  Briefcase,
  Check,
  X,
  ExclamationCircle,
  FileText,
  Key,
  PlusCircle,
  Eye,
  Map,
  CreditCard,
  Receipt,
  InfoCircle,
  ArrowLeft,
  ChevronRight,
  ChevronLeft,
  Shop,
  Lock,
  People,
  PersonBadge
} from "react-bootstrap-icons";
import { API_BASE_URL } from "../../constants/api_constants";


const TAXPAYERS_ENDPOINT = `${API_BASE_URL}/taxpayers`;
const FORMES_ENDPOINT = `${API_BASE_URL}/formes`;
const LOCALITES_ENDPOINT = `${API_BASE_URL}/localites`;
const MARCHES_ENDPOINT = `${API_BASE_URL}/marches`;

export default function AddContribuableFromActivity() {
  const navigate = useNavigate();
  const location = useLocation();
  
  // ✅ Récupérer les infos de l'utilisateur connecté
  const userData = JSON.parse(sessionStorage.getItem('userData') || '{}');
  const userRoleId = userData?.role_id || null;
  const userMarcheId = userData?.id_marche || null;
  const hasMarket = !!userMarcheId;

  // ✅ LOGS DE DÉBOGAGE
  console.log("=== DÉBOGAGE ADD CONTRIBUABLE FROM ACTIVITY ===");
  console.log("userData:", userData);
  console.log("userRoleId:", userRoleId);
  console.log("userMarcheId:", userMarcheId);
  console.log("hasMarket:", hasMarket);

  // ✅ Déterminer les rôles
  const isAdminEntite = userRoleId === 1002;
  const isAdminPrincipal = userRoleId === 1003;
  const isAdminMarche = userRoleId === 1005;
  const isCollecteur = userRoleId === 1013;
  const isAgentMarche = userRoleId === 1012;

  // ✅ Déterminer si l'utilisateur peut voir les radios Formel/Informel
  const canSeeRadios = (hasMarket && (isAgentMarche || isCollecteur)) || isAdminPrincipal || isAdminMarche;

  // ✅ Déterminer si l'utilisateur peut enregistrer des contribuables
  const canRegister = !isAdminEntite && (isAgentMarche || isCollecteur || isAdminPrincipal || isAdminMarche);

  // ✅ Déterminer si l'utilisateur peut voir le select des marchés
  const canSeeMarcheSelect = (hasMarket || isAdminPrincipal) && !isAdminEntite;

  // ✅ LOG pour vérifier
  console.log("canSeeRadios:", canSeeRadios);
  console.log("canRegister:", canRegister);
  console.log("canSeeMarcheSelect:", canSeeMarcheSelect);

  // ✅ Nouvel état pour le type de contribuable (Formel / Informel)
  const [contribuableType, setContribuableType] = useState('formel');
  
  // Récupérer l'ID de l'activité depuis l'URL
  const queryParams = new URLSearchParams(location.search);
  const activiteId = queryParams.get('activite_id');
  
  // États pour l'activité
  const [activity, setActivity] = useState(null);
  const [loadingActivity, setLoadingActivity] = useState(true);
  const [activityError, setActivityError] = useState(null);
  
  // Step management
  const [currentStep, setCurrentStep] = useState(0);
  
  const [loading, setLoading] = useState(false);
  const [formesJuridiques, setFormesJuridiques] = useState([]);
  const [loadingFormes, setLoadingFormes] = useState(false);
  const [alertMessage, setAlertMessage] = useState({ show: false, message: '', type: 'info' });
  const [formProgress, setFormProgress] = useState(0);
  
  // États pour les quartiers
  const [quartiers, setQuartiers] = useState([]);
  const [loadingQuartiers, setLoadingQuartiers] = useState(false);
  const [selectedQuartier, setSelectedQuartier] = useState(null);
  const [allLocalitesData, setAllLocalitesData] = useState([]);
  
  // ✅ États pour les marchés
  const [marches, setMarches] = useState([]);
  const [loadingMarches, setLoadingMarches] = useState(false);
  const [selectedMarche, setSelectedMarche] = useState(null);
  
  // États pour les taxes de l'activité
  const [activityTaxes, setActivityTaxes] = useState([]);
  const [loadingActivityTaxes, setLoadingActivityTaxes] = useState(false);
  const [showTaxesModal, setShowTaxesModal] = useState(false);
  
  // États pour la modal de réponse
  const [showResponseModal, setShowResponseModal] = useState(false);
  const [apiResponse, setApiResponse] = useState(null);
  
  // Types de localités
  const typeLabels = {
    1000: "Commune",
    1001: "Ville",
    1002: "Quartier",
    1003: "Arrondissement",
    1004: "Département",
    1005: "Province"
  };
  
  // Formulaire
  const [formData, setFormData] = useState({
    denomination: "",
    nom: "",
    prenom: "",
    forme_juridique: "",
    activite_contribuable: activiteId || "",
    telephone: "",
    email: "",
    adresse: "",
    quartier_id: "",
    code_postal: "",
    id_nat: "",
    rccm: "",
    nif: "",
    id_marche: hasMarket ? userMarcheId : ""
  });
  
  const defaultCurrency = sessionStorage.getItem("default_currency") || "XAF";
  
  const getTypeName = (typeCode) => typeLabels[typeCode] || "Localité";
  
  const getAuthToken = () => sessionStorage.getItem("authToken");
  
  const getHeaders = () => {
    const token = getAuthToken();
    const headers = { "Content-Type": "application/json", Accept: "application/json" };
    if (token) headers["Authorization"] = `Bearer ${token}`;
    return headers;
  };
  
  const showAlert = (message, type = 'danger', duration = 5000) => {
    setAlertMessage({ show: true, message, type });
    if (duration > 0) setTimeout(() => setAlertMessage({ show: false, message: '', type: 'info' }), duration);
  };
  
  const formatCurrency = (amount) => {
    const numAmount = parseFloat(amount) || 0;
    return numAmount.toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) + ' ' + defaultCurrency;
  };
  
  const formatFrequency = (value) => {
    const map = {
      daily: "Journalière", monthly: "Mensuelle", quarterly: "Trimestrielle",
      semiannual: "Semestrielle", annual: "Annuelle", one_off: "Paiement unique",
    };
    return map[value] || "Mensuelle";
  };
  
  // ✅ Gestionnaire pour le changement de type de contribuable
  const handleContribuableTypeChange = (type) => {
    console.log("Changement de type:", type);
    setContribuableType(type);
    if (type === 'informel') {
      const fullName = `${formData.nom || ''} ${formData.prenom || ''}`.trim();
      setFormData(prev => ({
        ...prev,
        denomination: fullName
      }));
    }
  };

  // ✅ Effet pour mettre à jour la dénomination en mode informel
  useEffect(() => {
    if (contribuableType === 'informel' && (formData.nom || formData.prenom)) {
      const fullName = `${formData.nom || ''} ${formData.prenom || ''}`.trim();
      if (fullName) {
        setFormData(prev => ({
          ...prev,
          denomination: fullName
        }));
      }
    }
  }, [contribuableType, formData.nom, formData.prenom]);

  // ✅ Options pour les marchés - filtrées selon le rôle
  const marcheOptions = canSeeMarcheSelect ? marches
    .filter(m => {
      if (hasMarket && !isAdminPrincipal) {
        return m.id_marche === userMarcheId;
      }
      return true;
    })
    .map(m => ({
      value: m.id_marche || m.id,
      label: `${m.id_marche || m.code_marche} - ${m.nom_marche}`,
      original: m
    })) : [];

  // ✅ Si l'utilisateur a un marché, le pré-sélectionner
  useEffect(() => {
    if (hasMarket && marches.length > 0 && canSeeMarcheSelect) {
      const userMarche = marches.find(m => m.id_marche === userMarcheId);
      if (userMarche) {
        setSelectedMarche({
          value: userMarche.id_marche,
          label: `${userMarche.id_marche} - ${userMarche.nom_marche}`,
          original: userMarche
        });
        setFormData(prev => ({
          ...prev,
          id_marche: userMarche.id_marche
        }));
      }
    }
  }, [marches, hasMarket, userMarcheId, canSeeMarcheSelect]);

  // Charger les détails de l'activité
  const fetchActivityDetails = async () => {
    if (!activiteId) {
      setActivityError("Aucun ID d'activité spécifié");
      setLoadingActivity(false);
      return;
    }
    
    try {
      setLoadingActivity(true);
      const response = await axios.get(`${API_BASE_URL}/activites/${activiteId}`, { headers: getHeaders() });
      
      if (response.data) {
        setActivity(response.data);
      } else {
        setActivityError("Activité non trouvée");
      }
    } catch (error) {
      console.error("Erreur chargement activité:", error);
      setActivityError("Impossible de charger les détails de l'activité");
    } finally {
      setLoadingActivity(false);
    }
  };
  
  // Charger les taxes de l'activité
  const fetchActivityTaxes = async () => {
    if (!activiteId) return;
    
    try {
      setLoadingActivityTaxes(true);
      const response = await axios.get(`${API_BASE_URL}/taxes-activity/${activiteId}`, { headers: getHeaders() });
      
      if (response.data && Array.isArray(response.data)) {
        setActivityTaxes(response.data);
      } else if (response.data && response.data.data && Array.isArray(response.data.data)) {
        setActivityTaxes(response.data.data);
      } else {
        setActivityTaxes([]);
      }
    } catch (error) {
      console.error("Erreur chargement taxes:", error);
      setActivityTaxes([]);
    } finally {
      setLoadingActivityTaxes(false);
    }
  };
  
  // Charger les localités
  const fetchAllLocalites = async () => {
    try {
      const response = await axios.get(LOCALITES_ENDPOINT, { headers: getHeaders() });
      let allLocalites = [];
      if (response.data && Array.isArray(response.data)) allLocalites = response.data;
      else if (response.data?.data && Array.isArray(response.data.data)) allLocalites = response.data.data;
      setAllLocalitesData(allLocalites);
      return allLocalites;
    } catch (error) {
      console.error("Erreur chargement localités:", error);
      return [];
    }
  };

  // Fonction pour obtenir la hiérarchie complète d'une localité
  const getLocaliteHierarchy = (localiteId, allData) => {
    const hierarchy = [];
    let current = allData.find(l => l.localite_id === localiteId);
    
    while (current && current.parent_id) {
      const parent = allData.find(l => l.localite_id === current.parent_id);
      if (parent) {
        hierarchy.unshift({
          nom: parent.nom,
          type: getTypeName(parent.type_code),
          id: parent.localite_id
        });
        current = parent;
      } else {
        break;
      }
    }
    
    return hierarchy;
  };

  // Fonction pour extraire les informations de localisation
  const extractLocationInfo = (localiteId, allData) => {
    if (!localiteId || allData.length === 0) return null;
    
    const foundLocalite = allData.find(l => l.localite_id === localiteId);
    if (!foundLocalite) return null;
    
    const chain = getLocaliteHierarchy(localiteId, allData);
    chain.push({ nom: foundLocalite.nom, type: getTypeName(foundLocalite.type_code), id: foundLocalite.localite_id });
    
    let province = null, departement = null, ville = null, commune = null, arrondissement = null, quartier = null;
    
    chain.forEach(loc => {
      switch (loc.type) {
        case 'Province': if (!province) province = loc.nom; break;
        case 'Département': if (!departement) departement = loc.nom; break;
        case 'Ville': if (!ville) ville = loc.nom; break;
        case 'Commune': if (!commune) commune = loc.nom; break;
        case 'Arrondissement': if (!arrondissement) arrondissement = loc.nom; break;
        case 'Quartier': if (!quartier) quartier = loc.nom; break;
        default: break;
      }
    });
    
    return { province, departement, ville, commune, arrondissement, quartier, chaineComplete: chain };
  };
  
  // Charger les quartiers
  const fetchQuartiers = async () => {
    const def_type_localite = Number(sessionStorage.getItem("def_type_localite") || 1002);
    try {
      setLoadingQuartiers(true);
      const allLocalites = await fetchAllLocalites();
      const quartiersList = allLocalites.filter(l => l.type_code === def_type_localite);
      const sortedQuartiers = [...quartiersList].sort((a, b) => (a.nom || '').localeCompare(b.nom || ''));
      setQuartiers(sortedQuartiers);
    } catch (error) {
      console.error("Erreur chargement quartiers:", error);
      setQuartiers([]);
    } finally {
      setLoadingQuartiers(false);
    }
  };
  
  // ✅ Charger les marchés
  const fetchMarches = async () => {
    if (!canSeeMarcheSelect) return;
    
    try {
      setLoadingMarches(true);
      const response = await axios.get(MARCHES_ENDPOINT, { 
        headers: getHeaders(),
        params: {
          per_page: 100
        }
      });
      
      let marchesData = [];
      if (response.data && response.data.code === 200) {
        marchesData = response.data.data || [];
      } else if (response.data && Array.isArray(response.data)) {
        marchesData = response.data;
      } else if (response.data && response.data.data && Array.isArray(response.data.data)) {
        marchesData = response.data.data;
      }
      
      setMarches(marchesData);
    } catch (error) {
      console.error("Erreur chargement marchés:", error);
      setMarches([]);
    } finally {
      setLoadingMarches(false);
    }
  };
  
  // Charger les formes juridiques
  const fetchFormesJuridiques = async () => {
    try {
      setLoadingFormes(true);
      const response = await axios.get(FORMES_ENDPOINT, { headers: getHeaders() });
      if (response.data && Array.isArray(response.data)) setFormesJuridiques(response.data);
    } catch (error) { setFormesJuridiques([]); } finally { setLoadingFormes(false); }
  };
  
  useEffect(() => {
    fetchActivityDetails();
    fetchFormesJuridiques();
    fetchQuartiers();
    fetchActivityTaxes();
    if (canSeeMarcheSelect) {
      fetchMarches();
    }
  }, [activiteId, canSeeMarcheSelect]);
  
  // Calcul de progression globale
  useEffect(() => {
    const fieldsWeight = {
      denomination: { weight: 25, required: true, step: 0 },
      telephone: { weight: 25, required: true, step: 2 },
      nom: { weight: 8, required: false, step: 0 },
      prenom: { weight: 8, required: false, step: 0 },
      forme_juridique: { weight: 8, required: false, step: 0 },
      email: { weight: 8, required: false, step: 2 },
      adresse: { weight: 8, required: false, step: 1 },
      quartier_id: { weight: 8, required: false, step: 1 },
      id_marche: { weight: 7, required: false, step: 0 },
      code_postal: { weight: 5, required: false, step: 1 },
      id_nat: { weight: 5, required: false, step: 0 },
      rccm: { weight: 5, required: false, step: 0 },
      nif: { weight: 5, required: false, step: 0 }
    };
    
    let totalProgress = 0;
    Object.entries(fieldsWeight).forEach(([field, config]) => {
      const value = formData[field];
      let isFilled = false;
      if (field === 'forme_juridique') isFilled = value && value !== "";
      else isFilled = value && typeof value === 'string' && value.trim().length > 0;
      if (isFilled) totalProgress += config.weight;
    });
    setFormProgress(Math.min(100, totalProgress));
  }, [formData]);
  
  // Vérifier si l'étape actuelle est valide
  const isCurrentStepValid = () => {
    switch (currentStep) {
      case 0: // Étape 1: Identification
        if (contribuableType === 'formel' || !canSeeRadios) {
          return formData.denomination?.trim().length > 0;
        } else {
          // Mode informel
          return formData.nom?.trim().length > 0 && formData.prenom?.trim().length > 0;
        }
      case 1: // Étape 2: Localisation
        return true;
      case 2: // Étape 3: Contact
        return formData.telephone?.trim().length > 0;
      default:
        return false;
    }
  };
  
  // Gestionnaires
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    
    if (contribuableType === 'informel' && (name === 'nom' || name === 'prenom')) {
      const newNom = name === 'nom' ? value : formData.nom;
      const newPrenom = name === 'prenom' ? value : formData.prenom;
      const fullName = `${newNom || ''} ${newPrenom || ''}`.trim();
      if (fullName) {
        setFormData(prev => ({
          ...prev,
          denomination: fullName
        }));
      }
    }
  };
  
  const handleQuartierChange = (selectedOption) => {
    setSelectedQuartier(selectedOption);
    setFormData(prev => ({ ...prev, quartier_id: selectedOption ? selectedOption.value : '' }));
  };
  
  // ✅ Gestionnaire pour le changement de marché
  const handleMarcheChange = (selectedOption) => {
    setSelectedMarche(selectedOption);
    setFormData(prev => ({
      ...prev,
      id_marche: selectedOption ? selectedOption.value : ''
    }));
  };
  
  // Options pour les quartiers
  const getQuartierHierarchy = (quartier, allData) => {
    const hierarchy = [];
    let current = quartier;
    while (current && current.parent_id) {
      const parent = allData.find(l => l.localite_id === current.parent_id);
      if (parent) {
        hierarchy.unshift({ nom: parent.nom, type: getTypeName(parent.type_code), id: parent.localite_id });
        current = parent;
      } else break;
    }
    return hierarchy;
  };
  
  const quartierOptions = quartiers.map(q => {
    const parent = allLocalitesData.find(a => a.localite_id === q.parent_id);
    let label = q.nom;
    if (parent) label += ` - ${parent.nom} (${getTypeName(parent.type_code)})`;
    else label += ` (Quartier)`;
    const hierarchy = getQuartierHierarchy(q, allLocalitesData);
    return { value: q.localite_id, label, original: q, parent, hierarchy };
  });
  
  const handleNext = () => {
    if (isCurrentStepValid()) {
      setCurrentStep(prev => Math.min(prev + 1, 2));
    } else {
      showAlert("Veuillez remplir tous les champs obligatoires", "warning");
    }
  };
  
  const handlePrevious = () => {
    setCurrentStep(prev => Math.max(prev - 1, 0));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // ✅ Validation selon le type
    if (contribuableType === 'formel' || !canSeeRadios) {
      if (!formData.denomination?.trim()) { 
        showAlert("La dénomination est obligatoire pour les contribuables formels", 'danger'); 
        return; 
      }
    } else {
      const fullName = `${formData.nom || ''} ${formData.prenom || ''}`.trim();
      if (!fullName) {
        showAlert("Le nom et prénom sont obligatoires pour les contribuables informels", 'danger');
        return;
      }
      if (!formData.nom?.trim()) {
        showAlert("Le nom est obligatoire pour les contribuables informels", 'danger');
        return;
      }
      if (!formData.prenom?.trim()) {
        showAlert("Le prénom est obligatoire pour les contribuables informels", 'danger');
        return;
      }
    }
    
    if (!formData.telephone?.trim()) { 
      showAlert("Le téléphone est obligatoire", 'danger'); 
      return; 
    }
    
    setLoading(true);
    try {
      // ✅ Préparer les données selon le type
      const submitData = {
        nom_entite: contribuableType === 'formel' || !canSeeRadios 
          ? formData.denomination.trim() 
          : `${formData.nom?.trim() || ''} ${formData.prenom?.trim() || ''}`.trim(),
        admin_full_name: formData.nom || "",
        first_name: formData.prenom || "",
        forme_juridique: formData.forme_juridique ? Number(formData.forme_juridique) : null,
        activite_contribuable: activiteId || "",
        telephone: formData.telephone.trim(),
        email: formData.email || "",
        admin_email: formData.email || "",
        adresse: formData.adresse || "",
        localite_id: formData.quartier_id || null,
        code_postal: formData.code_postal || "",
        id_nat: formData.id_nat?.trim() || null,
        rccm: formData.rccm?.trim() || null,
        nif: formData.nif?.trim() || null,
        id_marche: formData.id_marche || null,
        is_active: true,
        role_id: 1012,
        type_contribuable: contribuableType
      };

      // ✅ Pour les informels, on s'assure que la dénomination est bien nom + prénom
      if (contribuableType === 'informel' && canSeeRadios) {
        const fullName = `${formData.nom?.trim() || ''} ${formData.prenom?.trim() || ''}`.trim();
        submitData.nom_entite = fullName;
        submitData.denomination = fullName;
      }

      console.log("Données soumises:", submitData);
      
      const response = await axios.post(TAXPAYERS_ENDPOINT, submitData, { headers: getHeaders() });
      setApiResponse(response.data);
      setShowResponseModal(true);
      
      // Attendre 2 secondes avant d'imprimer pour laisser le temps aux taxes d'être synchronisées
      if (response.data.entite) {
        setTimeout(() => {
          generateFicheRecensement(response.data.entite, activity, activityTaxes);
        }, 2000);
      }
    } catch (error) {
      console.error('Erreur:', error);
      setApiResponse(error.response?.data || { error: error.message });
      setShowResponseModal(true);
    } finally {
      setLoading(false);
    }
  };
  
  // Composant Step Indicator
  const StepIndicator = () => {
    const steps = [
      { number: 1, title: "Identification", icon: <Building size={16} /> },
      { number: 2, title: "Localisation", icon: <Map size={16} /> },
      { number: 3, title: "Contact", icon: <Phone size={16} /> }
    ];
    
    return (
      <div className="step-indicator mb-4">
        <div className="steps-container">
          {steps.map((step, index) => (
            <div key={index} className={`step-item ${currentStep >= index ? 'active' : ''} ${currentStep > index ? 'completed' : ''}`}>
              <div className="step-circle">
                {currentStep > index ? <Check size={14} /> : step.number}
              </div>
              <div className="step-label">
                <span className="step-title">{step.title}</span>
              </div>
              {index < steps.length - 1 && <div className="step-line" />}
            </div>
          ))}
        </div>
      </div>
    );
  };

  const generateFicheRecensement = async (contribuableData, activiteInfoData, activityTaxes = [], localiteInfo = null, taxationNumber = null) => {
    console.log("=== GÉNÉRATION DE LA NOTE DE TAXATION ===");
    console.log("Taxes reçues:", activityTaxes?.length || 0);
    
    if (activityTaxes && activityTaxes.length > 0) {
      activityTaxes.forEach((tax, idx) => {
        console.log(`Taxe ${idx + 1}:`, {
          taxe_name: tax.taxe_name,
          type: tax.type,
          titre: tax.titre,
          default_amount: tax.default_amount,
          montant: tax.montant
        });
      });
    }
    
    // ========== APPEL API POUR RÉCUPÉRER L'ID_DOC ==========
    let documentInfo = { id_interne: null, date_create: null };
    
    try {
      const documentResponse = await axios.get(`${API_BASE_URL}/document_interne`, { headers: getHeaders() });
      if (documentResponse.data && documentResponse.data.id_interne) {
        documentInfo.id_interne = documentResponse.data.id_interne;
        documentInfo.date_create = documentResponse.data.date_create;
        console.log("✅ ID_DOC récupéré:", documentInfo.id_interne);
      } else {
        documentInfo.id_interne = `NT-${Date.now()}`;
      }
    } catch (error) {
      console.error("❌ Erreur lors de l'appel API /document_interne:", error);
      documentInfo.id_interne = `NT-${Date.now()}`;
    }
    
    const internalDocNumber = documentInfo.id_interne;
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentDay = String(currentDate.getDate()).padStart(2, '0');
    const currentMonth = String(currentDate.getMonth() + 1).padStart(2, '0');
    
    // Récupérer les informations de localisation
    let villeNom = "";
    let communeNom = "";
    let quartierNom = "";
    let numeroAdresse = "";
    let avenueNom = "";
    
    if (selectedQuartier && allLocalitesData.length > 0) {
      const locationInfo = extractLocationInfo(selectedQuartier.value, allLocalitesData);
      if (locationInfo) {
        villeNom = locationInfo.ville || "KINSHASA";
        communeNom = locationInfo.commune || "Lemba";
        quartierNom = locationInfo.quartier || selectedQuartier.original?.nom || "";
      }
    }
    
    const adresseBase = contribuableData?.adresse || formData?.adresse || "";
    const adresseParts = adresseBase.split(',');
    if (adresseParts.length >= 2) {
      numeroAdresse = adresseParts[0].trim().replace('N°', '').trim();
      avenueNom = adresseParts[1].trim();
    } else {
      numeroAdresse = adresseBase.replace('N°', '').trim() || "1132";
      avenueNom = "Itimbiri";
    }
    
    const getDenomination = () => {
      return contribuableData?.nom_contribuable || contribuableData?.nom_entite || formData?.denomination || "ETS MUANA MBOKA";
    };
    
    // FONCTIONS POUR EXTRAIRE LES DONNÉES DES TAXES
    const getTaxAmount = (tax) => {
      if (!tax) return 0;
      if (tax.default_amount && parseFloat(tax.default_amount) > 0) return parseFloat(tax.default_amount);
      if (tax.montant && parseFloat(tax.montant) > 0) return parseFloat(tax.montant);
      if (tax.montant_personnalise && parseFloat(tax.montant_personnalise) > 0) return parseFloat(tax.montant_personnalise);
      if (tax.amount && parseFloat(tax.amount) > 0) return parseFloat(tax.amount);
      return 0;
    };
    
    const getTaxName = (tax) => {
      if (!tax) return "Taxe";
      if (tax.taxe_name) return tax.taxe_name;
      if (tax.type) return tax.type;
      if (tax.titre) return tax.titre;
      if (tax.intitule) return tax.intitule;
      if (tax.name) return tax.name;
      if (tax.libelle) return tax.libelle;
      if (tax.nom_taxe) return tax.nom_taxe;
      return "Taxe";
    };
    
    // NORMALISER LES TAXES
    let normalizedTaxes = [];
    if (activityTaxes && Array.isArray(activityTaxes)) {
      normalizedTaxes = activityTaxes;
    } else if (activityTaxes?.data && Array.isArray(activityTaxes.data)) {
      normalizedTaxes = activityTaxes.data;
    } else if (activityTaxes?.taxes && Array.isArray(activityTaxes.taxes)) {
      normalizedTaxes = activityTaxes.taxes;
    }
    
    // CONSTRUIRE LA LISTE DES TAXES AVEC LEURS MONTANTS
    const taxesList = [];
    let montantTotal = 0;
    
    for (const tax of normalizedTaxes) {
      const montant = getTaxAmount(tax);
      const libelle = getTaxName(tax);
      
      if (montant > 0) {
        montantTotal += montant;
        taxesList.push({
          libelle: libelle,
          montant: montant,
          montantFormatted: montant.toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 0 })
        });
      }
    }
    
    const hasTaxesDue = taxesList.length > 0 && montantTotal > 0;
    
    // Générer les lignes du tableau
    const generateTaxRows = () => {
      let html = '';
      let lineNumber = 1;
      
      if (taxesList.length === 0) {
        html += `<tr style="border: 1px solid #000;">`;
        html += `<td colspan="3" style="padding: 8px; border: 1px solid #000; text-align: center;">Aucune taxe due pour le moment<\/td>`;
        html += `<\/tr>`;
      } else {
        for (const tax of taxesList) {
          html += `<tr style="border: 1px solid #000;">`;
          html += `<td style="padding: 8px; border: 1px solid #000; text-align: center;">${String(lineNumber).padStart(2, '0')}<\/td>`;
          html += `<td style="padding: 8px; border: 1px solid #000;">${tax.libelle}<\/td>`;
          html += `<td style="padding: 8px; border: 1px solid #000; text-align: right;">${tax.montantFormatted}<\/td>`;
          html += `<\/tr>`;
          lineNumber++;
        }
      }
      
      return html;
    };
    
    const getTaxationNumber = () => {
      if (taxationNumber) return taxationNumber;
      if (internalDocNumber) {
        return `${internalDocNumber} / 443 / LB / ECON / ${currentYear}`;
      }
      const contribuableId = contribuableData?.contribuable_id || ' ';
      return `${contribuableId} / 443 / LB / ECON / ${currentYear}`;
    };
    
    const htmlContent = `<!DOCTYPE html>
<html>
<head>
  <meta charset="UTF-8">
  <title>Note de taxation TPA</title>
  <style>
    * { margin: 0; padding: 0; box-sizing: border-box; }
    html, body { 
      height: 100%;
      margin: 0;
      padding: 0;
    }
    body { 
      font-family: 'Arial', 'Helvetica', sans-serif;
      background: white;
      font-size: 14px;
      display: flex;
      flex-direction: column;
      min-height: 100vh;
    }
    @media print {
      @page { size: A4; margin: 1.5cm; }
      body { padding: 0; margin: 0; }
    }
    .document { 
      max-width: 210mm; 
      margin: 0 auto; 
      background: white;
      flex: 1;
      display: flex;
      flex-direction: column;
      padding: 20px;
    }
    
    .main-content {
      flex: 1;
    }
    
    .header {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      margin-bottom: 15px;
    }
    .logo-left {
      width: 150px;
      text-align: left;
    }
    .logo-left img {
      width: 145px;
      height: auto;
    }
    .ville-title {
      text-align: center;
      flex: 1;
    }
    .ville-title h1 {
      font-size: 20px;
      font-weight: bold;
      margin: 0;
      letter-spacing: 2px;
    }
    .ville-title .commune {
      font-size: 14px;
      font-weight: bold;
      margin: 3px 0 0 0;
    }
    .ville-title .service {
      font-size: 12px;
      margin: 2px 0 0 0;
    }
    .logo-right {
      width: 130px;
      text-align: right;
    }
    .logo-right img {
      width: 120px;
      height: auto;
    }
    
    .main-title {
      text-align: center;
      margin: 20px 0 20px 0;
    }
    .main-title .note-title {
      font-size: 14px;
      font-weight: bold;
      text-decoration: underline;
      letter-spacing: 0.5px;
    }
    
    .corps {
      margin: 15px 0;
      line-height: 1.6;
      font-size: 13px;
    }
    .corps p {
      margin: 6px 0;
    }
    
    .tax-table {
      width: 100%;
      border-collapse: collapse;
      margin: 15px 0;
      font-size: 12px;
    }
    .tax-table th {
      border: 1px solid #000;
      padding: 8px;
      background-color: #f5f5f5;
      font-weight: bold;
      text-align: center;
    }
    .tax-table td {
      border: 1px solid #000;
      padding: 6px 8px;
    }
    
    .total-row {
      font-weight: bold;
      background-color: #f9f9f9;
    }
    
    .note-importante {
      margin: 15px 0;
      font-size: 11px;
      font-style: italic;
      line-height: 1.4;
    }
    .note-importante p {
      margin: 8px 0;
    }
    
    .signature {
      margin-top: 30px;
      text-align: center;
    }
    .signature p {
      margin: 3px 0;
    }
    
    .footer {
      margin-top: auto;
      font-size: 10px;
      text-align: center;
      border-top: 1px solid #ccc;
      padding-top: 8px;
      width: 100%;
    }
    .footer-logos {
      display: flex;
      justify-content: center;
      gap: 15px;
      margin-bottom: 5px;
    }
    
    .bold { font-weight: bold; }
    .text-center { text-align: center; }
    .text-right { text-align: right; }
    .mt-2 { margin-top: 8px; }
    
    .visa {
      text-align: center;
      margin-top: 5px;
    }
  </style>
</head>
<body>
  <div class="document">
    <div class="main-content">
      <div class="header">
        <div class="logo-left">
          <img src="${mairieLogo}" alt="Logo" />
        </div>
      </div><br>
      
      <div class="main-title">
        <div class="note-title">NOTE DE TAXATION N° ${getTaxationNumber()}</div>
      </div>
      
      <div class="corps">
        <p>Madame, Mademoiselle, Monsieur, Responsable des ETS(STE) <strong>${getDenomination()}</strong></p>
        <p>Sis(e) au <strong>${numeroAdresse || "..."}</strong>, quartier <strong>${quartierNom || "..."}</strong>, Commune de <strong>${communeNom || "Lemba"}</strong>;</p>
        ${hasTaxesDue ? `
        <p class="mt-2">Sauf erreur ou omission de notre part, vous êtes redevable envers le Trésor municipal d'un montant total de <strong>${montantTotal.toLocaleString('fr-FR')} Francs congolais</strong>, éclaté de la manière suivante :</p>
        ` : `
        <p class="mt-2">Nous vous informons que votre situation fiscale est à jour. Vous n'êtes actuellement redevable d'aucun montant auprès du Trésor municipal.</p>
        `}
      </div>
      
      ${hasTaxesDue ? `
      <table class="tax-table">
        <thead>
          <tr>
            <th style="width: 50px;">N°</th>
            <th>Libellé des Actes</th>
            <th style="width: 150px;">Montant dû</th>
          </tr>
        </thead>
        <tbody>
          ${generateTaxRows()}
          <tr class="total-row">
            <td colspan="2" style="padding: 8px; border: 1px solid #000; text-align: right; font-weight: bold;">MONTANT TOTAL DÛ EN FRANCS CONGOLAIS<\/td>
            <td style="padding: 8px; border: 1px solid #000; text-align: right; font-weight: bold;">${montantTotal.toLocaleString('fr-FR')}<\/td>
          <\/tr>
        </tbody>
      <\/table>
      
      <div class="note-importante">
        <p>Ce montant est à verser intégralement entre les mains du percepteur, endéans 8 jours francs, <strong>faute de quoi il vous sera appliqué une majoration de l'ordre de 20 % du montant à payer</strong>, conformément à la législation en la matière pour non-respect du délai qui vous a été imparti lors du dépôt de la présente note de taxation.</p>
        <p class="mt-2"><strong>N.B : Ce montant de la Taxe Professionnelle Annuelle (TPA) fixé conformément au canevas budgétaire de la Commune de ${communeNom || "Lemba"}, n'est pas négociable.</strong></p>
      </div>
      ` : ''}
      
      <div class="signature">
        <p>FAIT A ${villeNom.toUpperCase() || "KINSHASA"}, LE ${currentDay} / ${currentMonth} / ${currentYear}</p>
        <p class="mt-2 bold">LE CHEF DE SERVICE D'ASSIETTE</p>
      </div>
      <div class="visa"></div>
      <p>Visa BGM.</p>
    </div>
    
    <div class="footer">
      <p>VILLE DE KINSHASA - Commune de ${communeNom || "Lemba"} - Service de Comptabilité</p>
    </div>
  </div>
</body>
</html>`;
    
    const iframe = document.createElement('iframe');
    iframe.style.position = 'absolute';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = 'none';
    document.body.appendChild(iframe);
    
    const iframeDoc = iframe.contentWindow.document;
    iframeDoc.open();
    iframeDoc.write(htmlContent);
    iframeDoc.close();
    
    iframe.contentWindow.onload = () => {
      iframe.contentWindow.print();
      setTimeout(() => {
        if (document.body.contains(iframe)) document.body.removeChild(iframe);
      }, 1000);
    };
  };

  // ✅ Si l'utilisateur est Admin Entité (1002), bloquer l'accès
  if (isAdminEntite) {
    return (
      <React.Fragment>
        <Header />
        <div className="main main-app p-3 p-lg-4">
          <div className="container-fluid">
            <Card className="border-0 shadow-sm">
              <Card.Body className="text-center py-5">
                <div className="mb-4">
                  <div className="bg-warning bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center mx-auto" style={{ width: 80, height: 80 }}>
                    <Lock size={40} className="text-warning" />
                  </div>
                </div>
                <h4 className="fw-bold text-warning">Accès limité</h4>
                <p className="text-muted mb-4 max-width-500 mx-auto">
                  En tant qu'Admin Entité (hors marché), vous ne pouvez pas créer de contribuables.
                  <br />
                  <small className="d-block mt-2">
                    Les contribuables doivent être associés à un marché. Veuillez contacter un administrateur.
                  </small>
                </p>
                <Button variant="primary" onClick={() => navigate(-1)}>
                  Retour
                </Button>
              </Card.Body>
            </Card>
          </div>
        </div>
        <Footer />
      </React.Fragment>
    );
  }

  // ✅ Si l'utilisateur n'est pas autorisé à enregistrer
  if (!canRegister) {
    return (
      <React.Fragment>
        <Header />
        <div className="main main-app p-3 p-lg-4">
          <div className="container-fluid">
            <Card className="border-0 shadow-sm">
              <Card.Body className="text-center py-5">
                <div className="mb-4">
                  <div className="bg-warning bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center mx-auto" style={{ width: 80, height: 80 }}>
                    <Lock size={40} className="text-warning" />
                  </div>
                </div>
                <h4 className="fw-bold text-warning">Accès non autorisé</h4>
                <p className="text-muted mb-4 max-width-500 mx-auto">
                  Vous n'avez pas les droits nécessaires pour enregistrer des contribuables.
                  <br />
                  <small className="d-block mt-2">
                    Rôle actuel : {userRoleId || 'Non défini'} - ID Marché : {userMarcheId || 'Aucun'}
                  </small>
                </p>
                <Button variant="primary" onClick={() => navigate(-1)}>
                  Retour
                </Button>
              </Card.Body>
            </Card>
          </div>
        </div>
        <Footer />
      </React.Fragment>
    );
  }

  // Affichage du chargement de l'activité
  if (loadingActivity) {
    return (
      <>
        <Header />
        <div className="main main-app p-4">
          <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "70vh" }}>
            <div className="text-center">
              <Spinner animation="border" variant="primary" />
              <h5 className="mt-3">Chargement de l'activité...</h5>
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }
  
  // Affichage de l'erreur
  if (activityError || !activity) {
    return (
      <>
        <Header />
        <div className="main main-app p-4">
          <Alert variant="danger" className="text-center">
            <ExclamationCircle size={48} className="mb-3" />
            <h4>{activityError || "Activité non trouvée"}</h4>
            <Button variant="primary" onClick={() => navigate(-1)} className="mt-3">
              <ArrowLeft className="me-2" /> Retour
            </Button>
          </Alert>
        </div>
        <Footer />
      </>
    );
  }
  
  return (
    <React.Fragment>
      <Header />
      <div className="main main-app p-3 p-lg-4" style={{ background: "#f5f7fb", minHeight: "100vh" }}>
        <div className="container-fluid">
          
          {/* Header avec retour */}
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div>
              <ol className="breadcrumb mb-2">
                <li className="breadcrumb-item"><Link to="">Dashboard</Link></li>
                <li className="breadcrumb-item"><Link to="/agent/contribuables/Activites">Activités</Link></li>
                <li className="breadcrumb-item active">Nouveau contribuable</li>
              </ol>
              <Button variant="link" className="p-0 text-decoration-none" onClick={() => navigate(-1)}>
                <ArrowLeft className="me-2" /> Retour
              </Button>
            </div>
            {/* ✅ Badge d'information */}
            {hasMarket && (
              <Badge bg="info" className="mt-2">
                <Shop className="me-1" size={14} />
                Marché assigné : {userMarcheId} - Rôle : {isAgentMarche ? 'Agent' : isCollecteur ? 'Collecteur' : isAdminPrincipal ? 'Admin Principal' : userRoleId}
              </Badge>
            )}
            {isAdminPrincipal && (
              <Badge bg="primary" className="mt-2 ms-2">
                <PersonBadge className="me-1" size={14} />
                Admin Principal
              </Badge>
            )}
            {isCollecteur && !hasMarket && (
              <Badge bg="warning" className="mt-2 ms-2" style={{ color: '#000' }}>
                <Person className="me-1" size={14} />
                Collecteur - Mode Formel uniquement
              </Badge>
            )}
          </div>
          
          {/* Carte d'information de l'activité chargée depuis l'API */}
          <Card className="border-0 shadow-sm mb-4 bg-primary bg-opacity-10">
            <Card.Body className="py-3">
              <div className="d-flex align-items-center gap-3">
                <Briefcase size={24} className="text-primary" />
                <div>
                  <small className="text-muted">Activité sélectionnée</small>
                  <h5 className="mb-0">{activity.name}</h5>
                  <small className="text-muted">
                    Catégorie: {activity.cat_name || "Non catégorisée"} | ID: {activity.id_export}
                  </small>
                </div>
              </div>
            </Card.Body>
          </Card>
          
          {/* Step Indicator */}
          <StepIndicator />
          
          <Row>
            <Col lg={8}>
              <Card className="shadow-sm border-0 mb-4">
                <Card.Header className="bg-primary text-white d-flex align-items-center py-3">
                  <Building className="me-2" size={20} />
                  <span className="fw-semibold fs-5">
                    {currentStep === 0 && "Étape 1/3 - Identification"}
                    {currentStep === 1 && "Étape 2/3 - Localisation"}
                    {currentStep === 2 && "Étape 3/3 - Contact"}
                  </span>
                </Card.Header>
                <Card.Body className="p-4 bg-white">
                  <Form onSubmit={handleSubmit}>
                    
                    {/* ✅ SECTION : TYPE DE CONTRIBUABLE - UNIQUEMENT SI L'UTILISATEUR PEUT VOIR LES RADIOS */}
                    {canSeeRadios && (
                      <div className="mb-4">
                        <h6 className="text-primary mb-3 pb-2 border-bottom">
                          <People className="me-2" size={16} /> Type de contribuable
                        </h6>
                        <div className="d-flex gap-3">
                          <div 
                            className={`p-3 rounded-3 border cursor-pointer flex-grow-1 ${contribuableType === 'formel' ? 'bg-primary bg-opacity-10 border-primary' : 'bg-light border-secondary'}`}
                            style={{ cursor: 'pointer' }}
                            onClick={() => handleContribuableTypeChange('formel')}
                          >
                            <div className="d-flex align-items-center">
                              <div className={`rounded-circle p-2 me-3 ${contribuableType === 'formel' ? 'bg-primary' : 'bg-secondary'}`}>
                                <PersonBadge size={20} className="text-white" />
                              </div>
                              <div>
                                <div className="fw-bold">Formel</div>
                                <small className="text-muted">Entreprise avec dénomination sociale</small>
                              </div>
                              {contribuableType === 'formel' && (
                                <div className="ms-auto">
                                  <CheckCircle size={24} className="text-primary" />
                                </div>
                              )}
                            </div>
                          </div>
                          <div 
                            className={`p-3 rounded-3 border cursor-pointer flex-grow-1 ${contribuableType === 'informel' ? 'bg-success bg-opacity-10 border-success' : 'bg-light border-secondary'}`}
                            style={{ cursor: 'pointer' }}
                            onClick={() => handleContribuableTypeChange('informel')}
                          >
                            <div className="d-flex align-items-center">
                              <div className={`rounded-circle p-2 me-3 ${contribuableType === 'informel' ? 'bg-success' : 'bg-secondary'}`}>
                                <Person size={20} className="text-white" />
                              </div>
                              <div>
                                <div className="fw-bold">Informel</div>
                                <small className="text-muted">Particulier sans dénomination sociale</small>
                              </div>
                              {contribuableType === 'informel' && (
                                <div className="ms-auto">
                                  <CheckCircle size={24} className="text-success" />
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        <Form.Text className="text-muted d-block mt-2">
                          <InfoCircle className="me-1" size={14} />
                          {contribuableType === 'formel' 
                            ? 'Les contribuables formels sont des entreprises avec une dénomination sociale.' 
                            : 'Les contribuables informels sont des particuliers identifiés par leur nom et prénom.'}
                        </Form.Text>
                      </div>
                    )}
                    
                    {/* ÉTAPE 1: IDENTIFICATION */}
                    {currentStep === 0 && (
                      <>
                        {/* ✅ SECTION IDENTIFICATION - Masquée en mode informel */}
                        {!(contribuableType === 'informel' && canSeeRadios) ? (
                          <div className="mb-4">
                            <h6 className="text-primary mb-3 pb-2 border-bottom">
                              <Building className="me-2" size={16} /> Identification
                            </h6>
                            <Row>
                              <Col md={12}>
                                <Form.Group className="mb-3">
                                  <Form.Label className="fw-medium">
                                    Dénomination <span className="text-danger">*</span>
                                  </Form.Label>
                                  <Form.Control 
                                    type="text" 
                                    name="denomination" 
                                    value={formData.denomination} 
                                    onChange={handleChange} 
                                    placeholder="Nom de l'entreprise" 
                                    required 
                                  />
                                  <Form.Text className="text-muted">Nom complet de l'entreprise</Form.Text>
                                </Form.Group>
                              </Col>
                            </Row>
                          </div>
                        ) : (
                          // ✅ Message informatif en mode informel
                          <div className="mb-4">
                            <div className="p-3 bg-info bg-opacity-10 rounded-3 border border-info">
                              <div className="d-flex align-items-center">
                                <InfoCircle className="text-info me-2" size={24} />
                                <div>
                                  <div className="fw-bold text-info">Mode informel</div>
                                  <small className="text-muted">
                                    La dénomination sera automatiquement composée à partir du <strong>Nom</strong> et du <strong>Prénom</strong> saisis ci-dessous.
                                  </small>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                        
                        <div className="mb-4">
                          <h6 className="text-primary mb-3 pb-2 border-bottom"><Person className="me-2" size={16} /> Identité du responsable</h6>
                          <Row>
                            <Col md={6}>
                              <Form.Group className="mb-3">
                                <Form.Label>
                                  {canSeeRadios && contribuableType === 'informel' ? (
                                    <>Nom <span className="text-danger">*</span></>
                                  ) : (
                                    'Nom'
                                  )}
                                </Form.Label>
                                <Form.Control 
                                  type="text" 
                                  name="nom" 
                                  value={formData.nom} 
                                  onChange={handleChange} 
                                  placeholder="Nom" 
                                  required={canSeeRadios && contribuableType === 'informel'}
                                />
                              </Form.Group>
                            </Col>
                            <Col md={6}>
                              <Form.Group className="mb-3">
                                <Form.Label>
                                  {canSeeRadios && contribuableType === 'informel' ? (
                                    <>Prénom <span className="text-danger">*</span></>
                                  ) : (
                                    'Prénom'
                                  )}
                                </Form.Label>
                                <Form.Control 
                                  type="text" 
                                  name="prenom" 
                                  value={formData.prenom} 
                                  onChange={handleChange} 
                                  placeholder="Prénom" 
                                  required={canSeeRadios && contribuableType === 'informel'}
                                />
                              </Form.Group>
                            </Col>
                          </Row>
                          {canSeeRadios && contribuableType === 'informel' && formData.nom && formData.prenom && (
                            <div className="mt-2 p-2 bg-success bg-opacity-10 rounded-3">
                              <small className="text-success d-flex align-items-center">
                                <CheckCircle className="me-1" size={14} />
                                Dénomination générée : <strong className="ms-1">{`${formData.nom} ${formData.prenom}`}</strong>
                              </small>
                            </div>
                          )}
                        </div>
                        
                        <div className="mb-4">
                          <h6 className="text-primary mb-3 pb-2 border-bottom"><FileText className="me-2" size={16} /> Documents légaux</h6>
                          <Row>
                            <Col md={4}>
                              <Form.Group className="mb-3">
                                <Form.Label><CreditCard className="me-1" size={14} /> ID NAT</Form.Label>
                                <Form.Control type="text" name="id_nat" value={formData.id_nat} onChange={handleChange} placeholder="Ex: NAT123456789" />
                                <Form.Text className="text-muted">Optionnel</Form.Text>
                              </Form.Group>
                            </Col>
                            <Col md={4}>
                              <Form.Group className="mb-3">
                                <Form.Label><FileText className="me-1" size={14} /> RCCM</Form.Label>
                                <Form.Control type="text" name="rccm" value={formData.rccm} onChange={handleChange} placeholder="Ex: RC2024/001" />
                                <Form.Text className="text-muted">Optionnel</Form.Text>
                              </Form.Group>
                            </Col>
                            <Col md={4}>
                              <Form.Group className="mb-3">
                                <Form.Label><Key className="me-1" size={14} /> NIF</Form.Label>
                                <Form.Control type="text" name="nif" value={formData.nif} onChange={handleChange} placeholder="Ex: 1234567890" />
                                <Form.Text className="text-muted">Optionnel</Form.Text>
                              </Form.Group>
                            </Col>
                          </Row>
                        </div>
                        
                        <div className="mb-4">
                          <h6 className="text-primary mb-3 pb-2 border-bottom"><Briefcase className="me-2" size={16} /> Informations légales</h6>
                          <Row>
                            <Col md={12}>
                              <Form.Group className="mb-3">
                                <Form.Label>Forme juridique</Form.Label>
                                <Select
                                  options={formesJuridiques.map(f => ({ value: f.forme_id, label: f.libelle || f.code }))}
                                  value={formesJuridiques.find(f => f.forme_id === formData.forme_juridique) ? { value: formData.forme_juridique, label: formesJuridiques.find(f => f.forme_id === formData.forme_juridique)?.libelle } : null}
                                  onChange={(selected) => handleChange({ target: { name: 'forme_juridique', value: selected ? selected.value : '' } })}
                                  isLoading={loadingFormes}
                                  placeholder="Sélectionner une forme juridique..."
                                  className="react-select-container"
                                  classNamePrefix="react-select"
                                />
                              </Form.Group>
                            </Col>
                          </Row>
                        </div>

                        {/* ✅ Section Marché - UNIQUEMENT SI L'UTILISATEUR PEUT VOIR LES MARCHÉS */}
                        {canSeeMarcheSelect && (
                          <div className="mb-4">
                            <h6 className="text-primary mb-3 pb-2 border-bottom"><Shop className="me-2" size={16} /> Marché</h6>
                            <Row>
                              <Col md={12}>
                                <Form.Group>
                                  <Form.Label>Marché</Form.Label>
                                  {hasMarket && !isAdminPrincipal ? (
                                    <div className="p-3 bg-light rounded-3 border border-success">
                                      <div className="d-flex align-items-center">
                                        <Shop className="text-success me-2" size={20} />
                                        <div>
                                          <div className="fw-bold">
                                            {selectedMarche?.label || `Marché ${userMarcheId}`}
                                          </div>
                                          <small className="text-muted">
                                            Marché assigné à votre compte
                                          </small>
                                        </div>
                                        <Badge bg="success" className="ms-auto">
                                          <Check className="me-1" size={12} />
                                          Assigné
                                        </Badge>
                                      </div>
                                    </div>
                                  ) : (
                                    <Select
                                      options={marcheOptions}
                                      value={selectedMarche}
                                      onChange={handleMarcheChange}
                                      isLoading={loadingMarches}
                                      isClearable
                                      isSearchable
                                      placeholder={loadingMarches ? "Chargement des marchés..." : "Sélectionner un marché..."}
                                      noOptionsMessage={() => "Aucun marché trouvé"}
                                      className="react-select-container"
                                      classNamePrefix="react-select"
                                      styles={{
                                        control: (base) => ({
                                          ...base,
                                          padding: '2px 0',
                                          backgroundColor: '#f8f9fa',
                                          borderColor: '#dee2e6'
                                        }),
                                        option: (base, { isFocused, isSelected }) => ({
                                          ...base,
                                          backgroundColor: isSelected ? '#0d6efd' : isFocused ? '#e9ecef' : 'white',
                                          color: isSelected ? 'white' : '#212529',
                                          cursor: 'pointer',
                                          padding: '10px 12px'
                                        }),
                                        menu: (base) => ({
                                          ...base,
                                          zIndex: 9999
                                        })
                                      }}
                                    />
                                  )}
                                  <Form.Text className="text-muted">
                                    <Shop className="me-1" size={12} />
                                    {hasMarket && !isAdminPrincipal 
                                      ? "Le marché est automatiquement assigné à votre compte" 
                                      : "Sélectionnez le marché auquel est rattaché le contribuable"}
                                  </Form.Text>
                                </Form.Group>
                              </Col>
                            </Row>
                            {selectedMarche && !(hasMarket && !isAdminPrincipal) && (
                              <div className="mt-2 p-3 bg-light rounded-3">
                                <small className="text-muted d-flex align-items-center">
                                  <Shop className="me-2" size={14} />
                                  Marché sélectionné :
                                </small>
                                <div className="mt-1">
                                  <Badge bg="success" className="fs-6">
                                    <Shop className="me-1" size={14} />
                                    {selectedMarche.label}
                                  </Badge>
                                  {selectedMarche.original && (
                                    <div className="mt-2">
                                      <small className="text-muted">Détails du marché :</small>
                                      <div className="mt-1">
                                        <Badge bg="info" className="me-1">
                                          Code: {selectedMarche.original.code_marche || selectedMarche.original.id_marche || 'N/A'}
                                        </Badge>
                                        {selectedMarche.original.etat && (
                                          <Badge bg={selectedMarche.original.etat === 'Ouvert' ? 'success' : 'danger'}>
                                            {selectedMarche.original.etat}
                                          </Badge>
                                        )}
                                        {selectedMarche.original.superficie && (
                                          <Badge bg="secondary" className="ms-1">
                                            {selectedMarche.original.superficie} m²
                                          </Badge>
                                        )}
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                      </>
                    )}
                    
                    {/* ÉTAPE 2: LOCALISATION */}
                    {currentStep === 1 && (
                      <>
                        <div className="mb-4">
                          <h6 className="text-primary mb-3 pb-2 border-bottom"><Map className="me-2" size={16} /> Localisation</h6>
                          <Row>
                            <Col md={6}>
                              <Form.Group className="mb-3">
                                <Form.Label>Localité / Quartier</Form.Label>
                                <Select
                                  options={quartierOptions}
                                  value={selectedQuartier}
                                  onChange={handleQuartierChange}
                                  isLoading={loadingQuartiers}
                                  placeholder="Sélectionner une localité..."
                                  className="react-select-container"
                                  classNamePrefix="react-select"
                                />
                              </Form.Group>
                            </Col>
                            <Col md={6}>
                              <Form.Group className="mb-3">
                                <Form.Label><GeoAlt className="me-1" size={14} /> Adresse</Form.Label>
                                <Form.Control type="text" name="adresse" value={formData.adresse} onChange={handleChange} placeholder="Adresse complète" />
                              </Form.Group>
                            </Col>
                          </Row>
                          <Row>
                            <Col md={12}>
                              <Form.Group className="mb-3">
                                <Form.Label><GeoAlt className="me-1" size={14} /> Code postal</Form.Label>
                                <Form.Control type="text" name="code_postal" value={formData.code_postal} onChange={handleChange} placeholder="Code postal" />
                              </Form.Group>
                            </Col>
                          </Row>
                          
                          {selectedQuartier && (
                            <div className="mt-2 p-3 bg-light rounded-3">
                              <small className="text-muted d-flex align-items-center"><GeoAlt className="me-2" size={14} />Localisation sélectionnée :</small>
                              <div className="mt-2">
                                <Badge bg="primary" className="fs-6 mb-2">{selectedQuartier.original.nom} (Quartier)</Badge>
                                {selectedQuartier.parent && (
                                  <div className="mt-2">
                                    <small className="text-muted">Parent direct :</small>
                                    <div><Badge bg="secondary">{selectedQuartier.parent.nom} ({getTypeName(selectedQuartier.parent.type_code)})</Badge></div>
                                  </div>
                                )}
                              </div>
                            </div>
                          )}
                        </div>
                      </>
                    )}
                    
                    {/* ÉTAPE 3: CONTACT */}
                    {currentStep === 2 && (
                      <>
                        <div className="mb-4">
                          <h6 className="text-primary mb-3 pb-2 border-bottom"><Phone className="me-2" size={16} /> Contact</h6>
                          <Row>
                            <Col md={6}>
                              <Form.Group className="mb-3">
                                <Form.Label className="fw-medium">Téléphone <span className="text-danger">*</span></Form.Label>
                                <Form.Control 
                                  type="tel" 
                                  name="telephone" 
                                  value={formData.telephone} 
                                  onChange={(e) => handleChange({ target: { name: 'telephone', value: e.target.value.replace(/\D/g, '') } })} 
                                  placeholder="XXX XXX XXX" 
                                  required 
                                />
                              </Form.Group>
                            </Col>
                            <Col md={6}>
                              <Form.Group className="mb-3">
                                <Form.Label>Email</Form.Label>
                                <Form.Control 
                                  type="email" 
                                  name="email" 
                                  value={formData.email} 
                                  onChange={handleChange} 
                                  placeholder="exemple@email.com" 
                                />
                              </Form.Group>
                            </Col>
                          </Row>
                        </div>
                        
                        {/* Récapitulatif des informations */}
                        <div className="mt-4">
                          <h6 className="text-primary mb-3 pb-2 border-bottom"><InfoCircle className="me-2" size={16} /> Récapitulatif</h6>
                          <div className="bg-light p-3 rounded-3">
                            <Row className="mb-2">
                              <Col md={4}><small className="text-muted">Type :</small></Col>
                              <Col md={8}>
                                <Badge bg={contribuableType === 'formel' ? 'primary' : 'success'}>
                                  {contribuableType === 'formel' ? 'Formel' : 'Informel'}
                                </Badge>
                              </Col>
                            </Row>
                            <Row className="mb-2">
                              <Col md={4}><small className="text-muted">Dénomination :</small></Col>
                              <Col md={8}><strong>{formData.denomination || "-"}</strong></Col>
                            </Row>
                            <Row className="mb-2">
                              <Col md={4}><small className="text-muted">Nom complet :</small></Col>
                              <Col md={8}><strong>{formData.nom} {formData.prenom}</strong></Col>
                            </Row>
                            {selectedQuartier && (
                              <Row className="mb-2">
                                <Col md={4}><small className="text-muted">Localisation :</small></Col>
                                <Col md={8}><strong>{selectedQuartier.original.nom}</strong></Col>
                              </Row>
                            )}
                            {selectedMarche && (
                              <Row className="mb-2">
                                <Col md={4}><small className="text-muted">Marché :</small></Col>
                                <Col md={8}><strong>{selectedMarche.label}</strong></Col>
                              </Row>
                            )}
                            <Row className="mb-2">
                              <Col md={4}><small className="text-muted">Téléphone :</small></Col>
                              <Col md={8}><strong>{formData.telephone || "-"}</strong></Col>
                            </Row>
                            <Row>
                              <Col md={4}><small className="text-muted">Email :</small></Col>
                              <Col md={8}><strong>{formData.email || "-"}</strong></Col>
                            </Row>
                          </div>
                        </div>
                      </>
                    )}
                    
                    {alertMessage.show && (
                      <div className="mb-4 mt-3">
                        <Alert variant={alertMessage.type} dismissible onClose={() => setAlertMessage({ show: false, message: '', type: 'info' })}>
                          <div className="d-flex align-items-center">
                            {alertMessage.type === 'success' ? <Check className="me-2" /> : alertMessage.type === 'danger' ? <X className="me-2" /> : <ExclamationCircle className="me-2" />}
                            <span>{alertMessage.message}</span>
                          </div>
                        </Alert>
                      </div>
                    )}
                    
                    <hr className="my-4" />
                    
                    {/* Boutons de navigation */}
                    <div className="d-flex gap-3 justify-content-between">
                      <div>
                        {currentStep > 0 && (
                          <Button type="button" variant="outline-secondary" onClick={handlePrevious}>
                            <ChevronLeft className="me-2" /> Précédent
                          </Button>
                        )}
                      </div>
                      <div className="d-flex gap-3">
                        <Button type="button" variant="light" onClick={() => navigate(-1)}>Annuler</Button>
                        {currentStep < 2 ? (
                          <Button type="button" variant="primary" onClick={handleNext}>
                            Suivant <ChevronRight className="ms-2" />
                          </Button>
                        ) : (
                          <Button 
                            type="submit" 
                            variant="success" 
                            disabled={loading || !formData.telephone?.trim() || (contribuableType === 'formel' && !formData.denomination?.trim()) || (canSeeRadios && contribuableType === 'informel' && (!formData.nom?.trim() || !formData.prenom?.trim()))}
                          >
                            {loading ? <><Spinner animation="border" size="sm" className="me-2" />Enregistrement...</> : <><Save className="me-2" size={16} />Enregistrer le contribuable</>}
                          </Button>
                        )}
                      </div>
                    </div>
                  </Form>
                </Card.Body>
              </Card>
            </Col>
            
            <Col lg={4} style={{position:'relative'}}>
              {/* Panneau des taxes de l'activité */}
              <div style={{position:'sticky',top:'90px'}}>
              
              {activityTaxes.length > 0 && (
                <Card className="border-0 shadow-sm mb-4">
                  <Card.Header className="bg-info text-white py-3 border-0">
                    <div className="d-flex align-items-center">
                      <Receipt className="me-2" size={18} />
                      <span className="fw-semibold">Taxes héritées</span>
                    </div>
                  </Card.Header>
                  <Card.Body className="p-3">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <small className="text-muted">{activityTaxes.length} taxe(s) seront appliquées</small>
                      <Button variant="link" size="sm" className="p-0 text-decoration-none" onClick={() => setShowTaxesModal(true)}>
                        <Eye size={14} className="me-1" /> Détails
                      </Button>
                    </div>
                    <div className="taxes-preview">
                      {activityTaxes.slice(0, 5).map((tax, idx) => (
                        <div key={idx} className="d-flex justify-content-between align-items-center py-2 border-bottom">
                          <div className="d-flex align-items-center">
                            <Receipt size={12} className="text-primary me-2" />
                            <small className="fw-medium">{tax.taxe_name || tax.type}</small>
                          </div>
                          <div className="text-end">
                            <small className="text-primary fw-bold">{formatCurrency(tax.default_amount || tax.montant)}</small>
                          </div>
                        </div>
                      ))}
                      {activityTaxes.length > 5 && (
                        <div className="text-center mt-2">
                          <small className="text-muted">+ {activityTaxes.length - 5} autres taxes</small>
                        </div>
                      )}
                    </div>
                    <div className="alert alert-info mt-3 mb-0 py-2">
                      <InfoCircle size={14} className="me-2" />
                      <small>Ces taxes seront automatiquement héritées</small>
                    </div>
                  </Card.Body>
                </Card>
              )}
              
              {/* Carte d'aide */}
              <Card className="border-0 shadow-sm">
                <Card.Header className="bg-secondary bg-opacity-10 py-3 border-0">
                  <div className="d-flex align-items-center">
                    <InfoCircle className="me-2 text-secondary" size={18} />
                    <span className="fw-semibold">Aide</span>
                  </div>
                </Card.Header>
                <Card.Body className="p-3">
                  <ul className="list-unstyled mb-0">
                    <li className="mb-2"><CheckCircle size={14} className="text-success me-2" /><small>L'activité est pré-sélectionnée</small></li>
                    <li className="mb-2"><CheckCircle size={14} className="text-success me-2" /><small>Les taxes seront héritées automatiquement</small></li>
                    <li className="mb-2"><CheckCircle size={14} className="text-success me-2" /><small>Les champs avec * sont obligatoires</small></li>
                    <li className="mb-2"><CheckCircle size={14} className="text-success me-2" /><small>Navigation pas à pas pour faciliter la saisie</small></li>
                  </ul>
                </Card.Body>
              </Card>
              </div>
            </Col>
          </Row>
        </div>
        
        {/* Modals */}
        <Modal show={showTaxesModal} onHide={() => setShowTaxesModal(false)} size="lg" centered>
          <Modal.Header closeButton className="bg-primary text-white">
            <Modal.Title><Receipt className="me-2" size={20} />Taxes de l'activité</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="mb-3">
              <h6 className="mb-2">Activité : <Badge bg="primary" className="ms-2">{activity?.name}</Badge></h6>
              <p className="text-muted small">Cette activité comporte {activityTaxes.length} taxe(s) associée(s)</p>
            </div>
            
            {loadingActivityTaxes ? (
              <div className="text-center py-4"><Spinner animation="border" variant="primary" /><p className="mt-2">Chargement des taxes...</p></div>
            ) : activityTaxes.length === 0 ? (
              <div className="text-center py-4"><Receipt size={48} className="text-muted opacity-25 mb-3" /><p className="text-muted">Aucune taxe associée à cette activité</p></div>
            ) : (
              <div className="table-responsive">
                <Table hover>
                  <thead className="table-light"><tr><th>Code</th><th>Intitulé</th><th>Montant</th><th>Fréquence</th></tr></thead>
                  <tbody>
                    {activityTaxes.map((tax, idx) => (
                      <tr key={idx}>
                        <td><Badge bg="secondary">{tax.taxe_id || tax.id}</Badge></td>
                        <td><strong>{tax.taxe_name || tax.type || tax.titre}</strong>{tax.description && <small className="d-block text-muted">{tax.description.substring(0, 60)}...</small>}</td>
                        <td className="text-primary fw-bold">{formatCurrency(tax.default_amount || tax.montant || 0)}</td>
                        <td><Badge bg="info">{formatFrequency(tax.default_frequency) || 'Mensuelle'}</Badge></td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            )}
            
            <div className="alert alert-info mt-3">
              <div className="d-flex align-items-center"><InfoCircle className="me-2" size={18} /><small>Ces taxes seront automatiquement appliquées lors de la création du contribuable.</small></div>
            </div>
          </Modal.Body>
          <Modal.Footer><Button variant="secondary" onClick={() => setShowTaxesModal(false)}>Fermer</Button></Modal.Footer>
        </Modal>
        
        <Modal show={showResponseModal} onHide={() => setShowResponseModal(false)} size="lg" centered backdrop="static">
          <Modal.Header closeButton className={apiResponse?.entite ? "bg-success text-white" : "bg-danger text-white"}>
            <Modal.Title>{apiResponse?.entite ? <><CheckCircle className="me-2" size={24} />Contribuable créé avec succès !</> : <><ExclamationCircle className="me-2" size={24} />Erreur lors de la création</>}</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ maxHeight: '70vh', overflowY: 'auto' }}>
            {apiResponse?.entite ? (
              <>
                <div className="mb-4">
                  <h5 className="text-primary mb-3"><Building className="me-2" size={18} />Informations de l'entité</h5>
                  <div className="table-responsive"><table className="table table-bordered"><tbody>
                    <tr className="table-light"><td className="fw-semibold">ID Contribuable</td><td><code>{apiResponse.entite.contribuable_id}</code></td></tr>
                    <tr><td className="fw-semibold">Nom / Dénomination</td><td>{apiResponse.entite.nom_contribuable}</td></tr>
                    <tr className="table-light"><td className="fw-semibold">Téléphone</td><td>{apiResponse.entite.telephone}</td></tr>
                    <tr><td className="fw-semibold">Email</td><td>{apiResponse.entite.email}</td></tr>
                    {apiResponse.entite.id_marche && (
                      <tr className="table-light"><td className="fw-semibold">Marché</td><td><Badge bg="info">{apiResponse.entite.id_marche}</Badge></td></tr>
                    )}
                    {/* ✅ Utiliser la valeur retournée par l'API */}
                    {apiResponse.entite.type_contribuable && (
                      <tr><td className="fw-semibold">Type</td>
                        <td>
                          <Badge bg={apiResponse.entite.type_contribuable === 'formel' ? 'primary' : 'success'}>
                            {apiResponse.entite.type_contribuable === 'formel' ? 'Formel' : 'Informel'}
                          </Badge>
                        </td>
                      </tr>
                    )}
                  </tbody></table></div>
                </div>
              </>
            ) : (<Alert variant="danger"><ExclamationCircle className="me-2" />{apiResponse?.message || "Une erreur est survenue"}</Alert>)}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowResponseModal(false)}>Fermer</Button>
            {apiResponse?.entite && (
              <>
                <Button variant="info" onClick={() => generateFicheRecensement(apiResponse.entite, activity, activityTaxes)}>
                  <Printer className="me-2" /> Imprimer la note de taxation
                </Button>
                <Button variant="success" onClick={() => { setShowResponseModal(false); navigate(-1); }}>
                  <ArrowLeft className="me-2" /> Revenir
                </Button>
              </>
            )}
          </Modal.Footer>
        </Modal>
        
        <Footer />
      </div>
      
      <style>{`
        .form-control:focus, .form-select:focus { border-color: #0d6efd; box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.25); }
        .progress-bar { transition: width 0.5s ease; }
        .react-select-container { width: 100%; }
        .react-select__control { background-color: #f8f9fa !important; border-color: #dee2e6 !important; }
        .react-select__control:hover { border-color: #0d6efd !important; }
        .react-select__control--is-focused { border-color: #0d6efd !important; box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.25) !important; }
        .max-width-500 { max-width: 500px; }
        .cursor-pointer { cursor: pointer; }
        .cursor-pointer:hover { transform: translateY(-2px); transition: transform 0.2s; }
        
        /* Step Indicator Styles */
        .step-indicator {
          background: white;
          border-radius: 16px;
          padding: 20px;
          box-shadow: 0 2px 8px rgba(0,0,0,0.05);
        }
        
        .steps-container {
          display: flex;
          align-items: center;
          justify-content: space-between;
          position: relative;
        }
        
        .step-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          position: relative;
          flex: 1;
        }
        
        .step-circle {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          background: #e9ecef;
          color: #6c757d;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: bold;
          font-size: 16px;
          transition: all 0.3s ease;
          z-index: 2;
          position: relative;
        }
        
        .step-item.active .step-circle {
          background: #0d6efd;
          color: white;
          box-shadow: 0 0 0 4px rgba(13,110,253,0.2);
        }
        
        .step-item.completed .step-circle {
          background: #198754;
          color: white;
        }
        
        .step-label {
          margin-top: 10px;
          text-align: center;
        }
        
        .step-title {
          font-size: 12px;
          font-weight: 500;
          color: #6c757d;
        }
        
        .step-item.active .step-title {
          color: #0d6efd;
          font-weight: 600;
        }
        
        .step-line {
          position: absolute;
          top: 20px;
          left: 50%;
          width: 100%;
          height: 2px;
          background: #e9ecef;
          z-index: 1;
        }
        
        .step-item:last-child .step-line {
          display: none;
        }
        
        .step-item.completed .step-line {
          background: #198754;
        }
        
        @media (max-width: 768px) {
          .step-circle { width: 32px; height: 32px; font-size: 12px; }
          .step-title { font-size: 10px; }
          .step-label { margin-top: 6px; }
          .step-line { top: 16px; }
        }
      `}</style>
    </React.Fragment>
  );
}